import React, { useCallback, useMemo } from 'react'
import { recipeUtils } from '@jowtech/utils'

import { KEY_VALUES } from '../../constants'
import { COLORS, THEME } from '../../styles'

import Styled from './Like.styled'

const Like = ({ value, count, className, style, onClick, isLoading }) => {
  const likes = useMemo(() => {
    return count ? recipeUtils.getReadableLikes(count) : 0
  }, [count])

  const handleLikeClicked = useCallback(() => {
    if (onClick && !isLoading) {
      onClick()
    }
  }, [isLoading, onClick])

  return (
    <Styled
      className={className}
      style={style}
      onClick={handleLikeClicked}
      onKeyPress={(event) => {
        if (event.key === KEY_VALUES.ENTER) {
          handleLikeClicked()
        }
      }}
      isLoading={isLoading}
      tabIndex={0}
      role="button"
    >
      <Styled.heart
        name={value && !isLoading ? 'heart-fill-24' : 'heart-stroke-24'}
        fill={
          isLoading
            ? THEME.COLORS.foreground.secondary
            : value
              ? COLORS.primary
              : THEME.COLORS.foreground.primary
        }
        width={24}
        height={24}
      />
      {likes ? <Styled.count>{likes}</Styled.count> : null}
    </Styled>
  )
}

Like.defaultProps = {
  isLoading: false,
}

export default Like
